export default function({iconUrl, infoList},moduleIndex) {
    return `<section class="article-line__wrap visiblereport-luna" data-exposurelog='${JSON.stringify({module_id: 16, extralParam: {name: infoList.map(({articleTitle}) => articleTitle).join(',')}})}'>
        <h1 class="article-line__title">
            <img class="article-line__title__img" src="${iconUrl}" />
        </h1>
        <div class="article-line__swiper-wrap">
            <ul class="article-line__swiper swiper-wrapper">
                ${infoList.map(({linkUrl = '', tip = '', articleTitle = '', tag = ''} = {},index) => `
                    <li class="article-line__swiper-slide swiper-slide clickreport-luna-article">
                        <a class="article-line__swiper-slide__link clickreport" href="${linkUrl.replace(/^(http|https):/, '')}&tag=${tag}" data-tag="${tag}"
                        data-clickLog="${`${moduleIndex}_${index}_`}">
                            ${tip ? `<i class="article-line__swiper-slide__icon">${tip.slice(0,2)}</i>` : ''}
                            <span class="article-line__swiper-slide__txt">${articleTitle}</span>
                        </a>
                    </li>
                `).join('')}
            </ul>
        </div>
    </section>`
}